const langItArca = {
	cc_components_cc_order_summary_order_notes_label: 'Note per il punto vendita/prodotti non trovati',
	cc_components_cc_order_summary_order_notes_placeholder: 'Inserisci qui eventuali note per il punto vendita o segnalazioni di prodotti non trovati'
};
export default langItArca;
